/**
 * Rotas novas de Configurações que reaproveitam páginas existentes,
 * acrescentando o breadcrumb do padrão TiFlux por cima.
 */
import { CatalogsPage } from '@/features/catalogs/CatalogsPage';
import { ModelsPage } from '@/features/models/ModelsPage';
import { GroupsPage } from '@/features/groups/GroupsPage';
import { SettingsBreadcrumb } from '@/features/settings/settings-ui';

/** /settings/desks/catalogs — catálogos de serviços. */
export function CatalogsSettingsPage() {
  return (
    <div className="space-y-3">
      <div className="rounded-lg border bg-card px-4 py-3 shadow-xs">
        <SettingsBreadcrumb page="Catálogos de serviços" />
      </div>
      <CatalogsPage />
    </div>
  );
}

/** /settings/desks/models — modelos de resposta, apontamento e e-mail. */
export function ModelsSettingsPage() {
  return (
    <div className="space-y-3">
      <div className="rounded-lg border bg-card px-4 py-3 shadow-xs">
        <SettingsBreadcrumb page="Modelos" />
      </div>
      <ModelsPage />
    </div>
  );
}

/** /settings/groups — grupos de atendentes (seção Usuários). */
export function GroupsSettingsPage() {
  return (
    <div className="space-y-3">
      <div className="rounded-lg border bg-card px-4 py-3 shadow-xs">
        <SettingsBreadcrumb section="Usuários" page="Grupos de atendentes" />
      </div>
      <GroupsPage />
    </div>
  );
}
